export class ServiceUnavailableError {

  constructor() {
    this.message = "There is a problem connecting to the backend.";
    this.name = "ServiceUnavailableError";
    Error.captureStackTrace(this, ServiceUnavailableError);
  }


  static getStatus() {
    return 503;
  }

  static getMessage() {
    return "Service Unavailable"
  }

  static predicate(e) {
    return e.status === 503;
  }
}